"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const logos = [{
  id: "logo-1",
  name: "PropTech Solutions",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/logo_acme_corp.png"
}, {
  id: "logo-2",
  name: "Spatial Dynamics",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/logo_globex.png"
}, {
  id: "logo-3",
  name: "Virtual Realty",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/logo_soylent.png"
}, {
  id: "logo-4",
  name: "Digital Twin Co",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/logo_initech.png"
}, {
  id: "logo-5",
  name: "Architectural Innovators",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/logo_umbrella.png"
}, {
  id: "logo-6",
  name: "Future Spaces",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/logo_massive_dynamic.png"
}];
export default function TrustedByIndustryLeaders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="119809" id="strategic-partners" className="bg-background text-foreground py-16 sm:py-20 lg:py-24">
      <div ref={ref} className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <p className="text-[#9CA3AF] mb-10 text-center text-sm font-default font-semibold tracking-wider uppercase">
          Trusted by Global Leaders
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-10 sm:gap-x-16 lg:gap-x-24">
          {logos.map((logo, i) => <div key={logo.id} data-index={i} className="flex items-center justify-center">
              <img src={logo.src} alt={`${logo.name} logo`} className="h-8 w-auto object-contain opacity-50 grayscale transition-all duration-300 ease-in-out hover:opacity-100 hover:grayscale-0 sm:h-10" />
            </div>)}
        </div>
      </div>
    </section>;
}